import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { sendMonitorNotif } from '../services/analyticsService';

export function RouteErrorBoundary() {
  const error = useRouteError();

  let message: string = 'Unknown error';
  let stack: string | undefined = undefined;
  let status: number = 500;

  if (isRouteErrorResponse(error)) {
    message = error.statusText || 'Route error';
    status = error.status;
  } else if (error instanceof Error) {
    message = error.message;
    stack = error.stack;
  } else if (typeof error === 'object' && error !== null) {
    try {
      message = JSON.stringify(error);
    } catch {
      message = 'Unserializable error object';
    }
  } else if (typeof error === 'string') {
    message = error;
  }

  const combinedMessage = `Message: ${message}\nStatus: ${status}\nStack: ${stack ?? 'N/A'}`;

  sendMonitorNotif({
    type: 'boundaries',
    userId: 'N/A',
    source: 'route',
    error: {
      message: combinedMessage,
      status,
      stack,
    },
  });
  return (
    <div className="text-center p-6">
      <h1 className="text-2xl font-semibold text-gray-600 mb-4">Something went wrong :(</h1>
      <div className="flex justify-center gap-4">
        <button
          onClick={() => window.location.reload()}
          className="bg-deehiy text-white px-4 py-2 rounded hover:opacity-90 transition"
        >
          Reload the page
        </button>
        <a
          href="/"
          className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300 transition"
        >
          Go to home page
        </a>
      </div>
    </div>
  );
}
